import React from 'react';
import styles from '../Profile.module.css';

/**
 * Reusable component for displaying a label-value pair in profile view mode
 */
const ProfileFieldDisplay = ({ label, value }) => (
  <div className={styles.row}>
    <span className={styles.label}>{label}:</span>
    <span className={styles.value}>{value || '-'}</span>
  </div>
);

export default ProfileFieldDisplay;
